import { useMutation } from '@tanstack/react-query';

import { post } from 'src/utils/helpers/http';
import { useBaseAPIParams } from 'src/utils/hooks/useBaseAPIParams';

const READY_FOR_DELIVERY_URL = 'v2/delivery/ready-for-delivery';

export type RouteReadyMutation = {
  onError: (ex: any) => void;
  onSuccess: (data: any) => void;
};

export type RouteReadyRequest = {
  DeliveryRouteId: number;
};

export function useRouteReadyForDeliveryMutation({ onSuccess, onError }: RouteReadyMutation) {
  const baseAPIParams = useBaseAPIParams();
  return useMutation({
    mutationFn: async (req: RouteReadyRequest) => {
      const resp: any = await post(
        READY_FOR_DELIVERY_URL,
        {
          ...baseAPIParams,
          ...req,
        },
        { ignoreFormat: true },
      );

      if (!resp.Result) {
        throw resp.Message;
      }

      return resp;
    },
    mutationKey: ['route-ready-for-delivery'],
    onError,
    onSuccess,
  });
}
